export const isAMD = () => {
  return window.location?.host?.startsWith('amd.');
};
